export const windSpeedScalars = [
  {
    station: 'Aadorf / Tänikon',
    alt: 539,
    coordinate: {
      x: 2710518,
      y: 1259824,
    },
    jan: 1.7,
    feb: 1.7,
    mar: 1.8,
    apr: 1.6,
    may: 1.6,
    jun: 1.5,
    jul: 1.5,
    aug: 1.3,
    sep: 1.3,
    oct: 1.3,
    nov: 1.4,
    dec: 1.7,
    avgYear: 1.5,
    avgDir: 45,
    measurementHeight: 10,
  },
  {
    station: 'Acquarossa / Comprovasco',
    alt: 575,
    coordinate: {
      x: 2714985,
      y: 1146450,
    },
    jan: 2.0,
    feb: 2.2,
    mar: 2.6,
    apr: 2.7,
    may: 2.4,
    jun: 2.3,
    jul: 2.2,
    aug: 2.0,
    sep: 1.9,
    oct: 1.8,
    nov: 1.9,
    dec: 1.9,
    avgYear: 2.2,
    avgDir: 130,
    measurementHeight: 25.2,
  },
  {
    station: 'Adelboden',
    alt: 1321,
    coordinate: {
      x: 2609371,
      y: 1148939,
    },
    jan: 1.8,
    feb: 2.0,
    mar: 2.2,
    apr: 2.2,
    may: 2.2,
    jun: 2.2,
    jul: 2.1,
    aug: 1.9,
    sep: 1.8,
    oct: 1.7,
    nov: 1.8,
    dec: 1.9,
    avgYear: 2.0,
    avgDir: 38,
    measurementHeight: 31,
  },
  {
    station: 'Aigle',
    alt: 381,
    coordinate: {
      x: 2560403,
      y: 1130713,
    },
    jan: 2.0,
    feb: 2.3,
    mar: 2.5,
    apr: 2.7,
    may: 2.5,
    jun: 2.2,
    jul: 2.2,
    aug: 2.0,
    sep: 1.7,
    oct: 1.7,
    nov: 1.9,
    dec: 2.1,
    avgYear: 2.2,
    avgDir: 110,
    measurementHeight: 10,
  },
  {
    station: 'Altdorf',
    alt: 437,
    coordinate: {
      x: 2690180,
      y: 1193563,
    },
    jan: 2.4,
    feb: 2.6,
    mar: 2.6,
    apr: 3.0,
    may: 2.6,
    jun: 2.1,
    jul: 2.0,
    aug: 1.8,
    sep: 1.9,
    oct: 2.3,
    nov: 2.4,
    dec: 2.4,
    avgYear: 2.3,
    avgDir: 290,
    measurementHeight: 10,
  },

  {
    station: 'Basel / Binningen',
    alt: 316,
    coordinate: {
      x: 2610908,
      y: 1265611,
    },
    jan: 2.4,
    feb: 2.3,
    mar: 2.3,
    apr: 1.9,
    may: 1.8,
    jun: 1.8,
    jul: 1.8,
    aug: 1.6,
    sep: 1.6,
    oct: 1.7,
    nov: 2.0,
    dec: 2.4,
    avgYear: 2.0,
    avgDir: 350,
    measurementHeight: 12,
  },
  {
    station: 'Bern / Zollikofen',
    alt: 552,
    coordinate: {
      x: 2601934,
      y: 1204409,
    },
    jan: 1.8,
    feb: 2.0,
    mar: 2.2,
    apr: 2.1,
    may: 2.0,
    jun: 2.0,
    jul: 1.9,
    aug: 1.7,
    sep: 1.7,
    oct: 1.6,
    nov: 1.6,
    dec: 1.8,
    avgYear: 1.9,
    avgDir: 75,
    measurementHeight: 10,
  },
  {
    station: 'Buchs / Aarau',
    alt: 386,
    coordinate: {
      x: 2648396,
      y: 1248369,
    },
    jan: 1.6,
    feb: 1.6,
    mar: 1.7,
    apr: 1.5,
    may: 1.5,
    jun: 1.4,
    jul: 1.3,
    aug: 1.1,
    sep: 1.2,
    oct: 1.2,
    nov: 1.3,
    dec: 1.6,
    avgYear: 1.4,
    avgDir: 230,
    measurementHeight: 10,
  },
  {
    station: 'Bullet / La Frétaz',
    alt: 1205,
    coordinate: {
      x: 2534225,
      y: 1188081,
    },
    jan: 2.4,
    feb: 2.5,
    mar: 2.5,
    apr: 2.5,
    may: 2.4,
    jun: 2.3,
    jul: 2.3,
    aug: 2.1,
    sep: 2.1,
    oct: 2.2,
    nov: 2.3,
    dec: 2.4,
    avgYear: 2.3,
    avgDir: 230,
    measurementHeight: 10,
  },
  {
    station: 'Chasseral',
    alt: 1594,
    coordinate: {
      x: 2570845,
      y: 1220157,
    },
    jan: 10.3,
    feb: 10.0,
    mar: 9.0,
    apr: 7.8,
    may: 7.4,
    jun: 7.1,
    jul: 7.1,
    aug: 6.7,
    sep: 7.3,
    oct: 8.4,
    nov: 9.3,
    dec: 10.7,
    avgYear: 8.4,
    avgDir: 155,
    measurementHeight: 10,
  },

  {
    station: 'Chur',
    alt: 556,
    coordinate: {
      x: 2759466,
      y: 1193152,
    },
    jan: 2.5,
    feb: 2.8,
    mar: 3.1,
    apr: 3.3,
    may: 3.1,
    jun: 3.0,
    jul: 2.9,
    aug: 2.6,
    sep: 2.5,
    oct: 2.5,
    nov: 2.6,
    dec: 2.5,
    avgYear: 2.8,
    avgDir: 70,
    measurementHeight: 18.3,
  },
  {
    station: 'Cimetta',
    alt: 1661,
    coordinate: {
      x: 2704433,
      y: 1117457,
    },
    jan: 2.5,
    feb: 2.4,
    mar: 2.6,
    apr: 2.7,
    may: 2.6,
    jun: 2.5,
    jul: 2.4,
    aug: 2.3,
    sep: 2.4,
    oct: 2.3,
    nov: 2.5,
    dec: 2.4,
    avgYear: 2.5,
    avgDir: 240,
    measurementHeight: 10,
  },
  {
    station: 'Col du Grand St-Bernard',
    alt: 2472,
    coordinate: {
      x: 2579191,
      y: 1079754,
    },
    jan: 5.5,
    feb: 5.7,
    mar: 5.7,
    apr: 5.6,
    may: 5.2,
    jun: 5.0,
    jul: 5.0,
    aug: 4.7,
    sep: 5.2,
    oct: 5.3,
    nov: 5.7,
    dec: 5.7,
    avgYear: 5.4,
    avgDir: 355,
    measurementHeight: 25.2,
  },
  {
    station: 'Davos',
    alt: 1594,
    coordinate: {
      x: 2783519,
      y: 1187458,
    },
    jan: 1.5,
    feb: 1.8,
    mar: 2.0,
    apr: 2.3,
    may: 2.5,
    jun: 2.6,
    jul: 2.7,
    aug: 2.5,
    sep: 2.4,
    oct: 2.1,
    nov: 1.8,
    dec: 1.7,
    avgYear: 2.2,
    avgDir: 68,
    measurementHeight: 15,
  },
  {
    station: 'Disentis',
    alt: 1197,
    coordinate: {
      x: 2708190,
      y: 1173793,
    },
    jan: 0.9,
    feb: 0.9,
    mar: 1.2,
    apr: 1.3,
    may: 1.3,
    jun: 1.3,
    jul: 1.3,
    aug: 1.2,
    sep: 1.1,
    oct: 1.0,
    nov: 0.9,
    dec: 0.8,
    avgYear: 1.1,
    avgDir: 18,
    measurementHeight: 10,
  },

  {
    station: 'Engelberg',
    alt: 1035,
    coordinate: {
      x: 2674161,
      y: 1186069,
    },
    jan: 1.6,
    feb: 1.7,
    mar: 1.9,
    apr: 2.3,
    may: 2.2,
    jun: 2.0,
    jul: 1.9,
    aug: 1.8,
    sep: 1.7,
    oct: 1.6,
    nov: 1.7,
    dec: 1.6,
    avgYear: 1.8,
    avgDir: 3,
    measurementHeight: 28.2,
  },
  {
    station: 'Evolène / Villa',
    alt: 1825,
    coordinate: {
      x: 2605411,
      y: 1106748,
    },
    jan: 1.3,
    feb: 1.3,
    mar: 1.6,
    apr: 1.9,
    may: 1.9,
    jun: 1.9,
    jul: 1.9,
    aug: 1.7,
    sep: 1.5,
    oct: 1.4,
    nov: 1.3,
    dec: 1.3,
    avgYear: 1.6,
    avgDir: 40,
    measurementHeight: 10,
  },
  {
    station: 'Fahy',
    alt: 596,
    coordinate: {
      x: 2562464,
      y: 1252675,
    },
    jan: 3.1,
    feb: 3.1,
    mar: 3.1,
    apr: 2.6,
    may: 2.4,
    jun: 2.2,
    jul: 2.2,
    aug: 2.1,
    sep: 2.2,
    oct: 2.4,
    nov: 2.6,
    dec: 3.1,
    avgYear: 2.6,
    avgDir: 205,
    measurementHeight: 10,
  },
  {
    station: 'Genève / Cointrin',
    alt: 410,
    coordinate: {
      x: 2498904,
      y: 1122631,
    },
    jan: 2.5,
    feb: 2.7,
    mar: 2.9,
    apr: 2.8,
    may: 2.6,
    jun: 2.5,
    jul: 2.3,
    aug: 2.1,
    sep: 2.2,
    oct: 2.1,
    nov: 2.3,
    dec: 2.6,
    avgYear: 2.5,
    avgDir: 225,
    measurementHeight: 10,
  },
  {
    station: 'Glarus',
    alt: 516,
    coordinate: {
      x: 2723756,
      y: 1210567,
    },
    jan: 1.6,
    feb: 1.8,
    mar: 2.3,
    apr: 2.9,
    may: 2.8,
    jun: 2.6,
    jul: 2.5,
    aug: 2.2,
    sep: 2.0,
    oct: 1.8,
    nov: 1.8,
    dec: 1.6,
    avgYear: 2.2,
    avgDir: 165,
    measurementHeight: 10,
  },

  {
    station: 'Grimsel Hospiz',
    alt: 1980,
    coordinate: {
      x: 2668583,
      y: 1158214,
    },
    jan: 5.8,
    feb: 5.6,
    mar: 5.2,
    apr: 4.9,
    may: 4.5,
    jun: 4.2,
    jul: 4.2,
    aug: 4.1,
    sep: 4.4,
    oct: 5.3,
    nov: 5.8,
    dec: 5.8,
    avgYear: 5.0,
    avgDir: 285,
    measurementHeight: 12,
  },
  {
    station: 'Gösgen',
    alt: 380,
    coordinate: {
      x: 2640422,
      y: 1245949,
    },
    jan: 2.4,
    feb: 2.3,
    mar: 2.3,
    apr: 2.0,
    may: 1.9,
    jun: 1.7,
    jul: 1.6,
    aug: 1.4,
    sep: 1.4,
    oct: 1.6,
    nov: 1.9,
    dec: 2.3,
    avgYear: 1.9,
    avgDir: 210,
    measurementHeight: 10,
  },
  {
    station: 'Gütsch, Andermatt',
    alt: 2286,
    coordinate: {
      x: 2690087,
      y: 1167480,
    },
    jan: 7.0,
    feb: 6.8,
    mar: 6.7,
    apr: 6.8,
    may: 6.4,
    jun: 5.5,
    jul: 5.3,
    aug: 5.3,
    sep: 5.7,
    oct: 6.6,
    nov: 7.1,
    dec: 7.1,
    avgYear: 6.4,
    avgDir: 297,
    measurementHeight: 13.5,
  },
  {
    station: 'Güttingen',
    alt: 440,
    coordinate: {
      x: 2738422,
      y: 1273962,
    },
    jan: 2.4,
    feb: 2.5,
    mar: 2.5,
    apr: 2.3,
    may: 2.2,
    jun: 2.1,
    jul: 2.1,
    aug: 2.0,
    sep: 2.0,
    oct: 2.0,
    nov: 2.1,
    dec: 2.4,
    avgYear: 2.2,
    avgDir: 215,
    measurementHeight: 12,
  },
  {
    station: 'Hörnli',
    alt: 1132,
    coordinate: {
      x: 2713517,
      y: 1247756,
    },
    jan: 4.7,
    feb: 4.5,
    mar: 4.5,
    apr: 3.7,
    may: 3.5,
    jun: 3.1,
    jul: 3.2,
    aug: 3.2,
    sep: 3.4,
    oct: 4.0,
    nov: 4.3,
    dec: 4.7,
    avgYear: 3.9,
    avgDir: 185,
    measurementHeight: 15.1,
  },
  {
    station: 'Interlaken',
    alt: 577,
    coordinate: {
      x: 2633023,
      y: 1169091,
    },
    jan: 1.6,
    feb: 1.7,
    mar: 2.0,
    apr: 2.2,
    may: 2.1,
    jun: 2.0,
    jul: 1.9,
    aug: 1.7,
    sep: 1.6,
    oct: 1.5,
    nov: 1.6,
    dec: 1.7,
    avgYear: 1.8,
    avgDir: 235,
    measurementHeight: 10,
  },
  {
    station: 'Jungfraujoch',
    alt: 3571,
    coordinate: {
      x: 2641938,
      y: 1155287,
    },
    jan: 7.7,
    feb: 7.5,
    mar: 7.3,
    apr: 6.5,
    may: 6.0,
    jun: 5.3,
    jul: 5.1,
    aug: 4.8,
    sep: 5.6,
    oct: 6.5,
    nov: 7.6,
    dec: 7.9,
    avgYear: 6.5,
    avgDir: 132,
    measurementHeight: 10,
  },
  {
    station: 'La Chaux-de-Fonds',
    alt: 1017,
    coordinate: {
      x: 2550919,
      y: 1214861,
    },
    jan: 2.5,
    feb: 2.6,
    mar: 2.6,
    apr: 2.5,
    may: 2.4,
    jun: 2.2,
    jul: 2.1,
    aug: 1.9,
    sep: 2.1,
    oct: 2.2,
    nov: 2.3,
    dec: 2.6,
    avgYear: 2.3,
    avgDir: 212,
    measurementHeight: 10,
  },
  {
    station: 'La Dôle',
    alt: 1669,
    coordinate: {
      x: 2497059,
      y: 1142372,
    },
    jan: 9.7,
    feb: 9.6,
    mar: 8.8,
    apr: 7.5,
    may: 7.2,
    jun: 6.8,
    jul: 6.5,
    aug: 6.3,
    sep: 6.9,
    oct: 7.9,
    nov: 9.0,
    dec: 9.9,
    avgYear: 8.0,
    avgDir: 10,
    measurementHeight: 10.5,
  },
  {
    station: 'Le Moléson',
    alt: 1974,
    coordinate: {
      x: 2567718,
      y: 1155076,
    },
    jan: 6.3,
    feb: 6.2,
    mar: 5.6,
    apr: 4.8,
    may: 4.6,
    jun: 4.6,
    jul: 4.5,
    aug: 4.5,
    sep: 4.5,
    oct: 5.1,
    nov: 6.0,
    dec: 6.8,
    avgYear: 5.3,
    avgDir: 67,
    measurementHeight: 23.3,
  },

  {
    station: 'Leibstadt',
    alt: 341,
    coordinate: {
      x: 2656374,
      y: 1272121,
    },
    jan: 2.0,
    feb: 2.1,
    mar: 2.2,
    apr: 2.1,
    may: 2.0,
    jun: 1.9,
    jul: 1.9,
    aug: 1.6,
    sep: 1.6,
    oct: 1.6,
    nov: 1.7,
    dec: 2.0,
    avgYear: 1.9,
    avgDir: 200,
    measurementHeight: 10,
  },
  {
    station: 'Locarno / Monti',
    alt: 366,
    coordinate: {
      x: 2704166,
      y: 1114315,
    },
    jan: 1.1,
    feb: 1.3,
    mar: 1.6,
    apr: 1.7,
    may: 1.6,
    jun: 1.6,
    jul: 1.6,
    aug: 1.5,
    sep: 1.3,
    oct: 1.2,
    nov: 1.1,
    dec: 1.0,
    avgYear: 1.4,
    avgDir: 79,
    measurementHeight: 19.2,
  },
  {
    station: 'Lugano',
    alt: 273,
    coordinate: {
      x: 2717874,
      y: 1095882,
    },
    jan: 1.5,
    feb: 1.7,
    mar: 2.1,
    apr: 2.0,
    may: 1.8,
    jun: 1.8,
    jul: 1.8,
    aug: 1.7,
    sep: 1.6,
    oct: 1.5,
    nov: 1.5,
    dec: 1.5,
    avgYear: 1.7,
    avgDir: 100,
    measurementHeight: 37.3,
  },
  {
    station: 'Luzern',
    alt: 454,
    coordinate: {
      x: 2665544,
      y: 1209849,
    },
    jan: 1.5,
    feb: 1.6,
    mar: 1.8,
    apr: 1.8,
    may: 1.7,
    jun: 1.6,
    jul: 1.6,
    aug: 1.4,
    sep: 1.4,
    oct: 1.3,
    nov: 1.3,
    dec: 1.4,
    avgYear: 1.5,
    avgDir: 185,
    measurementHeight: 40.9,
  },
  {
    station: 'Lägern',
    alt: 844,
    coordinate: {
      x: 2672251,
      y: 1259459,
    },
    jan: 5.3,
    feb: 5.1,
    mar: 5.1,
    apr: 4.5,
    may: 4.3,
    jun: 4.1,
    jul: 4.0,
    aug: 3.9,
    sep: 4.3,
    oct: 4.7,
    nov: 4.8,
    dec: 5.4,
    avgYear: 4.6,
    avgDir: 45,
    measurementHeight: 28.7,
  },
  {
    station: 'Magadino / Cadenazzo',
    alt: 203,
    coordinate: {
      x: 2715479,
      y: 1113160,
    },
    jan: 1.3,
    feb: 1.5,
    mar: 2.0,
    apr: 2.1,
    may: 1.9,
    jun: 1.9,
    jul: 1.9,
    aug: 1.7,
    sep: 1.5,
    oct: 1.3,
    nov: 1.2,
    dec: 1.2,
    avgYear: 1.6,
    avgDir: 8,
    measurementHeight: 10,
  },
  {
    station: 'Montana',
    alt: 1422,
    coordinate: {
      x: 2601708,
      y: 1127488,
    },
    jan: 1.8,
    feb: 1.9,
    mar: 2.2,
    apr: 2.5,
    may: 2.3,
    jun: 2.0,
    jul: 1.9,
    aug: 1.7,
    sep: 1.8,
    oct: 1.9,
    nov: 2.1,
    dec: 1.9,
    avgYear: 2.0,
    avgDir: 30,
    measurementHeight: 10,
  },
  {
    station: 'Napf',
    alt: 1403,
    coordinate: {
      x: 2638137,
      y: 1206079,
    },
    jan: 5.4,
    feb: 5.1,
    mar: 4.7,
    apr: 3.7,
    may: 3.6,
    jun: 3.4,
    jul: 3.5,
    aug: 3.5,
    sep: 3.7,
    oct: 4.2,
    nov: 4.7,
    dec: 5.5,
    avgYear: 4.3,
    avgDir: 225,
    measurementHeight: 15,
  },
  {
    station: 'Neuchâtel',
    alt: 485,
    coordinate: {
      x: 2563086,
      y: 1205559,
    },
    jan: 2.8,
    feb: 2.9,
    mar: 3.1,
    apr: 2.7,
    may: 2.7,
    jun: 2.6,
    jul: 2.6,
    aug: 2.3,
    sep: 2.4,
    oct: 2.3,
    nov: 2.4,
    dec: 2.9,
    avgYear: 2.6,
    avgDir: 200,
    measurementHeight: 21.6,
  },
  {
    station: 'Nyon / Changins',
    alt: 458,
    coordinate: {
      x: 2506877,
      y: 1139573,
    },
    jan: 2.6,
    feb: 2.8,
    mar: 3.0,
    apr: 2.8,
    may: 2.7,
    jun: 2.6,
    jul: 2.6,
    aug: 2.3,
    sep: 2.4,
    oct: 2.2,
    nov: 2.3,
    dec: 2.6,
    avgYear: 2.6,
    avgDir: 135,
    measurementHeight: 10,
  },

  {
    station: 'Payerne',
    alt: 490,
    coordinate: {
      x: 2562130,
      y: 1184611,
    },
    jan: 2.2,
    feb: 2.4,
    mar: 2.4,
    apr: 2.2,
    may: 2.1,
    jun: 1.9,
    jul: 1.9,
    aug: 1.7,
    sep: 1.7,
    oct: 1.7,
    nov: 1.9,
    dec: 2.2,
    avgYear: 2.0,
    avgDir: 235,
    measurementHeight: 10,
  },
  {
    station: 'Pilatus',
    alt: 2105,
    coordinate: {
      x: 2661904,
      y: 1203410,
    },
    jan: 6.1,
    feb: 5.7,
    mar: 5.3,
    apr: 4.8,
    may: 4.2,
    jun: 3.7,
    jul: 3.4,
    aug: 3.6,
    sep: 4.1,
    oct: 5.0,
    nov: 5.8,
    dec: 6.3,
    avgYear: 4.8,
    avgDir: 213,
    measurementHeight: 7.6,
  },
  {
    station: 'Piotta',
    alt: 990,
    coordinate: {
      x: 2695880,
      y: 1152264,
    },
    jan: 2.3,
    feb: 2.5,
    mar: 2.8,
    apr: 2.9,
    may: 2.8,
    jun: 2.9,
    jul: 2.9,
    aug: 2.6,
    sep: 2.4,
    oct: 1.9,
    nov: 2.1,
    dec: 2.1,
    avgYear: 2.5,
    avgDir: 174,
    measurementHeight: 10,
  },
  {
    station: 'Piz Corvatsch',
    alt: 3294,
    coordinate: {
      x: 2783155,
      y: 1143524,
    },
    jan: 6.9,
    feb: 6.7,
    mar: 6.4,
    apr: 5.2,
    may: 4.6,
    jun: 4.1,
    jul: 3.8,
    aug: 3.7,
    sep: 4.1,
    oct: 5.2,
    nov: 6.2,
    dec: 6.7,
    avgYear: 5.3,
    avgDir: 202,
    measurementHeight: 24.7,
  },
  {
    station: 'Plaffeien',
    alt: 1042,
    coordinate: {
      x: 2586828,
      y: 1177406,
    },
    jan: 3.3,
    feb: 3.3,
    mar: 3.4,
    apr: 2.9,
    may: 2.7,
    jun: 2.7,
    jul: 2.7,
    aug: 2.5,
    sep: 2.6,
    oct: 2.6,
    nov: 2.8,
    dec: 3.3,
    avgYear: 2.9,
    avgDir: 315,
    measurementHeight: 10,
  },

  {
    station: 'Poschiavo / Robbia',
    alt: 1078,
    coordinate: {
      x: 2801993,
      y: 1136248,
    },
    jan: 2.3,
    feb: 2.5,
    mar: 3.0,
    apr: 2.8,
    may: 2.4,
    jun: 2.2,
    jul: 2.1,
    aug: 1.8,
    sep: 1.7,
    oct: 1.7,
    nov: 2.0,
    dec: 2.2,
    avgYear: 2.2,
    avgDir: 40,
    measurementHeight: 10,
  },
  {
    station: 'Pully',
    alt: 455,
    coordinate: {
      x: 2540819,
      y: 1151510,
    },
    jan: 1.7,
    feb: 1.8,
    mar: 1.8,
    apr: 1.8,
    may: 1.8,
    jun: 1.8,
    jul: 1.8,
    aug: 1.7,
    sep: 1.8,
    oct: 1.6,
    nov: 1.6,
    dec: 1.7,
    avgYear: 1.7,
    avgDir: 79,
    measurementHeight: 10,
  },
  {
    station: 'Robièi',
    alt: 1898,
    coordinate: {
      x: 2682587,
      y: 1144090,
    },
    jan: 2.4,
    feb: 2.5,
    mar: 2.4,
    apr: 2.2,
    may: 2.3,
    jun: 2.4,
    jul: 2.1,
    aug: 1.9,
    sep: 1.9,
    oct: 1.8,
    nov: 2.2,
    dec: 2.3,
    avgYear: 2.2,
    avgDir: 115,
    measurementHeight: 12,
  },

  {
    station: 'Rünenberg',
    alt: 611,
    coordinate: {
      x: 2633252,
      y: 1253846,
    },
    jan: 3.1,
    feb: 3.0,
    mar: 3.0,
    apr: 2.6,
    may: 2.3,
    jun: 2.1,
    jul: 2.1,
    aug: 1.9,
    sep: 2.0,
    oct: 2.3,
    nov: 2.6,
    dec: 3.2,
    avgYear: 2.5,
    avgDir: 18,
    measurementHeight: 10,
  },
  {
    station: 'S. Bernardino',
    alt: 1638,
    coordinate: {
      x: 2734116,
      y: 1147293,
    },
    jan: 2.7,
    feb: 3.0,
    mar: 2.8,
    apr: 2.5,
    may: 2.3,
    jun: 2.3,
    jul: 2.4,
    aug: 2.2,
    sep: 2.1,
    oct: 2.0,
    nov: 2.2,
    dec: 2.5,
    avgYear: 2.4,
    avgDir: 135,
    measurementHeight: 24.7,
  },
  {
    station: 'Samedan',
    alt: 1708,
    coordinate: {
      x: 2787250,
      y: 1155684,
    },
    jan: 1.6,
    feb: 1.9,
    mar: 2.3,
    apr: 2.6,
    may: 2.8,
    jun: 2.7,
    jul: 2.7,
    aug: 2.6,
    sep: 2.4,
    oct: 2.2,
    nov: 1.7,
    dec: 1.6,
    avgYear: 2.3,
    avgDir: 248,
    measurementHeight: 10,
  },
  {
    station: 'Schaffhausen',
    alt: 438,
    coordinate: {
      x: 2688703,
      y: 1282803,
    },
    jan: 3.7,
    feb: 3.7,
    mar: 3.9,
    apr: 3.5,
    may: 3.5,
    jun: 3.3,
    jul: 3.3,
    aug: 3.0,
    sep: 3.2,
    oct: 3.2,
    nov: 3.2,
    dec: 3.7,
    avgYear: 3.4,
    avgDir: 195,
    measurementHeight: 53,
  },
  {
    station: 'Scuol',
    alt: 1303,
    coordinate: {
      x: 2817138,
      y: 1186393,
    },
    jan: 1.3,
    feb: 1.3,
    mar: 1.5,
    apr: 1.8,
    may: 1.8,
    jun: 1.7,
    jul: 1.6,
    aug: 1.5,
    sep: 1.3,
    oct: 1.2,
    nov: 1.1,
    dec: 1.1,
    avgYear: 1.4,
    avgDir: 188,
    measurementHeight: 10,
  },
  {
    station: 'Sion',
    alt: 482,
    coordinate: {
      x: 2591632,
      y: 1118583,
    },
    jan: 1.5,
    feb: 1.9,
    mar: 2.5,
    apr: 2.9,
    may: 2.8,
    jun: 2.9,
    jul: 2.9,
    aug: 2.6,
    sep: 2.3,
    oct: 1.7,
    nov: 1.5,
    dec: 1.4,
    avgYear: 2.2,
    avgDir: 197,
    measurementHeight: 10,
  },
  {
    station: 'St. Gallen',
    alt: 775,
    coordinate: {
      x: 2747865,
      y: 1254587,
    },
    jan: 2.1,
    feb: 2.2,
    mar: 2.4,
    apr: 2.3,
    may: 2.2,
    jun: 2.1,
    jul: 2.1,
    aug: 1.9,
    sep: 1.8,
    oct: 1.8,
    nov: 1.9,
    dec: 2.1,
    avgYear: 2.1,
    avgDir: 270,
    measurementHeight: 16.3,
  },
  {
    station: 'Stabio',
    alt: 351,
    coordinate: {
      x: 2716048,
      y: 1077971,
    },
    jan: 0.9,
    feb: 1.1,
    mar: 1.3,
    apr: 1.3,
    may: 1.2,
    jun: 1.2,
    jul: 1.2,
    aug: 1.1,
    sep: 1.0,
    oct: 0.9,
    nov: 0.9,
    dec: 0.9,
    avgYear: 1.1,
    avgDir: 230,
    measurementHeight: 10,
  },
  {
    station: 'Säntis',
    alt: 2501,
    coordinate: {
      x: 2744188,
      y: 1234920,
    },
    jan: 8.0,
    feb: 7.9,
    mar: 7.2,
    apr: 5.3,
    may: 4.8,
    jun: 4.9,
    jul: 5.1,
    aug: 4.9,
    sep: 5.3,
    oct: 6.3,
    nov: 7.1,
    dec: 8.1,
    avgYear: 6.2,
    avgDir: 192,
    measurementHeight: 10.7,
  },
  {
    station: 'Ulrichen',
    alt: 1345,
    coordinate: {
      x: 2666747,
      y: 1150766,
    },
    jan: 1.0,
    feb: 1.4,
    mar: 1.9,
    apr: 2.3,
    may: 2.4,
    jun: 2.4,
    jul: 2.2,
    aug: 2.0,
    sep: 1.8,
    oct: 1.5,
    nov: 1.2,
    dec: 1.0,
    avgYear: 1.8,
    avgDir: 28,
    measurementHeight: 10,
  },
  {
    station: 'Vaduz',
    alt: 457,
    coordinate: {
      x: 2757723,
      y: 1221699,
    },
    jan: 2.1,
    feb: 2.2,
    mar: 2.3,
    apr: 2.4,
    may: 2.1,
    jun: 1.9,
    jul: 1.8,
    aug: 1.7,
    sep: 1.7,
    oct: 1.8,
    nov: 1.9,
    dec: 2.1,
    avgYear: 2.0,
    avgDir: 117,
    measurementHeight: 10,
  },
  {
    station: 'Visp',
    alt: 639,
    coordinate: {
      x: 2631150,
      y: 1128024,
    },
    jan: 2.4,
    feb: 2.9,
    mar: 3.8,
    apr: 4.2,
    may: 3.9,
    jun: 3.5,
    jul: 3.4,
    aug: 2.9,
    sep: 2.9,
    oct: 2.7,
    nov: 2.8,
    dec: 2.4,
    avgYear: 3.2,
    avgDir: 175,
    measurementHeight: 10,
  },
  {
    station: 'Weissfluhjoch',
    alt: 2691,
    coordinate: {
      x: 2780615,
      y: 1189634,
    },
    jan: 6.3,
    feb: 6.1,
    mar: 6.1,
    apr: 5.8,
    may: 5.0,
    jun: 4.6,
    jul: 4.3,
    aug: 3.9,
    sep: 4.4,
    oct: 5.0,
    nov: 6.0,
    dec: 6.4,
    avgYear: 5.3,
    avgDir: 115,
    measurementHeight: 10,
  },
  {
    station: 'Wynau',
    alt: 421,
    coordinate: {
      x: 2626405,
      y: 1233849,
    },
    jan: 2.1,
    feb: 2.0,
    mar: 2.1,
    apr: 1.9,
    may: 1.8,
    jun: 1.6,
    jul: 1.5,
    aug: 1.3,
    sep: 1.4,
    oct: 1.5,
    nov: 1.6,
    dec: 2.0,
    avgYear: 1.7,
    avgDir: 220,
    measurementHeight: 10,
  },
  {
    station: 'Wädenswil',
    alt: 485,
    coordinate: {
      x: 2693847,
      y: 1230744,
    },
    jan: 1.8,
    feb: 1.9,
    mar: 1.9,
    apr: 1.9,
    may: 1.9,
    jun: 1.9,
    jul: 1.8,
    aug: 1.7,
    sep: 1.7,
    oct: 1.6,
    nov: 1.7,
    dec: 1.9,
    avgYear: 1.8,
    avgDir: 200,
    measurementHeight: 29.5,
  },
  {
    station: 'Zermatt',
    alt: 1638,
    coordinate: {
      x: 2624297,
      y: 1097574,
    },
    jan: 1.2,
    feb: 1.5,
    mar: 1.7,
    apr: 2.2,
    may: 2.3,
    jun: 2.3,
    jul: 2.2,
    aug: 2.0,
    sep: 1.9,
    oct: 1.6,
    nov: 1.4,
    dec: 1.2,
    avgYear: 1.8,
    avgDir: 230,
    measurementHeight: 10,
  },
  {
    station: 'Zürich / Affoltern',
    alt: 443,
    coordinate: {
      x: 2681433,
      y: 1253547,
    },
    jan: 1.9,
    feb: 1.9,
    mar: 2.0,
    apr: 1.7,
    may: 1.7,
    jun: 1.6,
    jul: 1.5,
    aug: 1.3,
    sep: 1.3,
    oct: 1.4,
    nov: 1.5,
    dec: 1.8,
    avgYear: 1.6,
    avgDir: 202,
    measurementHeight: 10,
  },
  {
    station: 'Zürich / Fluntern',
    alt: 555,
    coordinate: {
      x: 2685117,
      y: 1248065,
    },
    jan: 2.3,
    feb: 2.3,
    mar: 2.5,
    apr: 2.1,
    may: 2.1,
    jun: 1.9,
    jul: 1.9,
    aug: 1.7,
    sep: 1.8,
    oct: 1.8,
    nov: 2.0,
    dec: 2.2,
    avgYear: 2.1,
    avgDir: 45,
    measurementHeight: 28,
  },
  {
    station: 'Zürich / Kloten',
    alt: 426,
    coordinate: {
      x: 2682711,
      y: 1259338,
    },
    jan: 2.8,
    feb: 2.8,
    mar: 2.9,
    apr: 2.7,
    may: 2.6,
    jun: 2.4,
    jul: 2.4,
    aug: 2.1,
    sep: 2.2,
    oct: 2.2,
    nov: 2.3,
    dec: 2.7,
    avgYear: 2.5,
    avgDir: 205,
    measurementHeight: 10.5,
  },
];
